import * as yup from 'yup';

export interface IPaymentOption {
	cardholderName: string;
	cardNumber: string;
	cvc: string;
	expiryDate: string;
	save: boolean;
}

export const paymentOptionInitialValues: IPaymentOption = {
	cardholderName: '',
	cardNumber: '',
	cvc: '',
	expiryDate: '',
	save: false,
};

export const paymentOptionSchema = yup.object().shape({
	cardholderName: yup.string().required('required'),
	cardNumber: yup
		.string()
		.matches(/^[0-9]{15,20}$/, 'wrongFormat')
		.required('required'),
	cvc: yup
		.string()
		.matches(/^[0-9]{3}$/, 'wrongFormat')
		.required('required'),
	expiryDate: yup
		.string()
		.matches(/^([0-9]{4}|[0-9]{2}\/([0-9]{2}){1,2})$/, 'wrongFormat')
		.required('required'),
	save: yup.boolean(),
});
